import { render, staticRenderFns } from "./CookiesBar.vue?vue&type=template&id=e64e3852&scoped=true&"
import script from "./CookiesBar.vue?vue&type=script&lang=js&"
export * from "./CookiesBar.vue?vue&type=script&lang=js&"
import style0 from "./CookiesBar.vue?vue&type=style&index=0&id=e64e3852&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64e3852",
  null
  
)

export default component.exports